/**
 * Validation Module
 *
 * Gestisce tutte le validazioni della sidebar e le condizioni per il checkout
 */

export {
  validate_external_conditions,
  should_lock_sidebar,
  can_proceed_to_checkout
} from './validation-manager'